// extracted by mini-css-extract-plugin
module.exports = {"AppHeader":"app-header_AppHeader__tbrxM"};